import { AccordionActiveState } from "@src/components/common/Accordion/Accordion.types";

interface FaqQuestions {
  question: string;
  answer: string;
  buttonLabel?: string;
  inititalVariant?: AccordionActiveState;
}

export const faqQuestions: FaqQuestions[] = [
  {
    question: "questions.one.question",
    answer: "questions.one.answer",
    buttonLabel: "questions.one.button",
    inititalVariant: "default"
  },
  {
    question: "questions.two.question",
    answer: "questions.two.answer"
  },
  {
    question: "questions.three.question",
    answer: "questions.three.answer"
  },
  {
    question: "questions.four.question",
    answer: "questions.four.answer"
  },
  {
    question: "questions.five.question",
    answer: "questions.five.answer"
  },
  {
    question: "questions.six.question",
    answer: "questions.six.answer"
  },
  {
    question: "questions.seven.question",
    answer: "questions.seven.answer"
  },
  {
    question: "questions.eight.question",
    answer: "questions.eight.answer"
  },
  {
    question: "questions.nine.question",
    answer: "questions.nine.answer"
  },
  {
    question: "questions.teen.question",
    answer: "questions.teen.answer"
  }
];
